export const REPORTED_ISSUE = "Reported Issue";
export const JOB_DESCRIPTION = "Job Description";
export const CUSTOMER_NAME = "Customer Name";
export const TECHNICIAN = "Technician";
export const WARRANTY_START_DATE = "Warranty Start Date";
export const WARRANTY_END_DATE = "Warranty End Date";
export const START_DATE = "Start Date";
export const END_DATE_LABEL = "End date";
export const END_DATE = "Completion Date";
export const PRIORITY_LEVEL = "Priority Level";
export const PRODUCT_CODE = "Product Code";
export const RATE = "Rate";
export const QUANTITY = "Quantity";
export const AMOUNT = "Amount";
export const AVAILABLE_QUANTITY = "Available Quantity";
export const ENGINE_NO_1 = "Engine No. 1";
export const ENGINE_NO_2 = "Engine No. 2";
export const ENGINE_NO_3 = "Engine No. 3";
export const CHASSIS_NO = "Chassis No"

export const OPTIONS =  [
        { label: 'Low', value: 'Low' },
        { label: 'Medium', value: 'Medium' },
        { label: 'High', value: 'High' },
      ];
     export const getStatusColor = (status: string) => {
        switch (status) {
          case "In Progress":
            return "bg-primary text-white badge";
          case "Reopen":
            return "bg-danger text-white badge";
          case "Closed":
            return "bg-success text-white badge";
          default:
            return "bg-secondary text-white badge";
        }
      };
    
     export const getPriorityColor = (priority: string) => {
        switch (priority) {
          case "Medium":
            return "bg-primary text-white badge";
          case "High":
            return "bg-danger text-white badge";
          case "Low":
            return "bg-success text-white badge";
          default:
            return "bg-secondary text-white badge";
        }
      };